module.exports = __webpack_public_path__ + "static/media/404-small.d98d2764.jpg";